import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';
import { AuthProvider } from './contexts/AuthContext';
import SpreadsheetLogin from './pages/SpreadsheetLogin';
import ErpDashboard from './pages/ErpDashboard';
import ErpCustomers from './pages/ErpCustomers';
import ErpCustomerDetail from './pages/ErpCustomerDetail';
import ErpShipments from './pages/ErpShipments';
import ErpTracking from './pages/ErpTracking';
import ErpApprovals from './pages/ErpApprovals';
import ErpEmails from './pages/ErpEmails';
import ErpFinance from './pages/ErpFinance';
import ErpReports from './pages/ErpReports';
import ErpSettings from './pages/ErpSettings';
import ProtectedRoute from './components/ProtectedRoute';

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/login" replace />} />
          <Route path="/login" element={<SpreadsheetLogin />} />

          {/* ERP shell — the only app surface (Navy & Gold) */}
          <Route path="/erp" element={<ProtectedRoute><ErpDashboard /></ProtectedRoute>} />
          <Route path="/erp/customers" element={<ProtectedRoute><ErpCustomers /></ProtectedRoute>} />
          <Route path="/erp/customers/:id" element={<ProtectedRoute><ErpCustomerDetail /></ProtectedRoute>} />
          <Route path="/erp/shipments" element={<ProtectedRoute><ErpShipments /></ProtectedRoute>} />
          <Route path="/erp/tracking" element={<ProtectedRoute><ErpTracking /></ProtectedRoute>} />
          <Route path="/erp/approvals" element={<ProtectedRoute><ErpApprovals /></ProtectedRoute>} />
          <Route path="/erp/emails" element={<ProtectedRoute><ErpEmails /></ProtectedRoute>} />
          <Route path="/erp/finance" element={<ProtectedRoute><ErpFinance /></ProtectedRoute>} />
          <Route path="/erp/reports" element={<ProtectedRoute><ErpReports /></ProtectedRoute>} />
          <Route path="/erp/settings" element={<ProtectedRoute><ErpSettings /></ProtectedRoute>} />

          {/* Everything else (retired classic site + removed modules) → ERP */}
          <Route path="*" element={<Navigate to="/erp" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
